export const AUTH_STATE_KEY = 'com.procsy.contracteum.auth.state';
export const CERTIFICATE_STATE_KEY = 'com.procsy.contracteum.certificate.state';
